module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dkIZk"))).then(() => parcelRequire('cvs7o'));